import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  LiliRadioInput,
  LiliRadioInputVariant,
  SegmentedSwitch,
  Text,
} from '@lili/lili-frontend-common';
import { OnboardingFormFields } from '@Types/types';
import type { UBOFormFields } from '../UBOFormScheme';

export const UBOResidencyToggle = () => {
  const { t } = useTranslation();
  const { watch, setValue, clearErrors } = useFormContext<UBOFormFields>();

  const isUsResident = watch('isUsResident');

  const handleResidencyChange = (newValue: boolean) => {
    if (isUsResident !== newValue) {
      setValue('isUsResident', newValue, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      setValue(OnboardingFormFields.ZIP, '');
      setValue(OnboardingFormFields.STATE, null);
      setValue(OnboardingFormFields.COUNTRY, null);
      clearErrors();
    }
  };

  return (
    <div className='flex flex-row items-center sm:w-[480px] w-full'>
      <div className='gap-[16px] sm:flex hidden w-full'>
        <Text.H9>{t('pages.addOwner.residencyStatus')}</Text.H9>
        <LiliRadioInput
          name='isUsResident'
          value='us'
          checked={isUsResident}
          label={t('pages.addOwner.residencyToggle.usResident')}
          onChange={() => handleResidencyChange(true)}
          id='us-resident'
          data-testid='us-resident'
          variant={LiliRadioInputVariant.DOT}
        />
        <LiliRadioInput
          name='isUsResident'
          value='nonUs'
          checked={!isUsResident}
          label={t('pages.addOwner.residencyToggle.nonUsResident')}
          onChange={() => handleResidencyChange(false)}
          id='non-us-resident'
          data-testid='non-us-resident'
          variant={LiliRadioInputVariant.DOT}
        />
      </div>
      <div className='flex sm:hidden w-full items-center'>
        <SegmentedSwitch
          id='residency-toggle'
          options={[
            { label: t('pages.addOwner.residencyToggle.usResident'), value: 'us' },
            { label: t('pages.addOwner.residencyToggle.nonUsResident'), value: 'nonUs' },
          ]}
          value={isUsResident ? 'us' : 'nonUs'}
          onChange={(value: string) => handleResidencyChange(value === 'us')}
        />
      </div>
    </div>
  );
};
